import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { workflowService, ProgramStatusAuditLog } from '@/services/features/WorkflowService';

export const useTaskAuditLog = (taskId: number | null) => {
  const [taskAuditLogs, setTaskAuditLogs] = useState<ProgramStatusAuditLog[]>([]);
  const [auditLogsLoading, setAuditLogsLoading] = useState(false);
  const { hasuraToken } = useAuth();

  useEffect(() => {
    const fetchAuditLogs = async () => {
      if (!taskId || !hasuraToken) return;

      setAuditLogsLoading(true);
      try {
        const result = await workflowService.getTaskAuditLog(hasuraToken, taskId);
        setTaskAuditLogs(result.logs);
      } catch (error) {
        console.error('Error fetching task audit logs:', error);
        setTaskAuditLogs([]);
      } finally {
        setAuditLogsLoading(false);
      }
    };

    fetchAuditLogs();
  }, [taskId, hasuraToken]);

  return {
    taskAuditLogs,
    auditLogsLoading,
  };
};
